<script>
import { mapActions } from 'vuex'
import Auth from "../../layouts/auth";
import appConfig from "../../../../app.config";

import { required, email } from "vuelidate/lib/validators";

/**
 * Forgot-password component
 */
export default {
  page: {
    title: "Forgot-password",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      email: "",
      submitted: false,
      error: '',
      info: '',
      tryingToReset: false,
      isResetError: false,
      isResetInfo: false,
      showAlert: false,
      textAlert: '',
    };
  },
  components: {
    Auth,
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  watch: {
    showAlert: {
      handler: function (val, oldVal) {
        if (!val) {
          this.textAlert = '';
        }
      }
    },
    isResetError: {
      handler: function (val, oldVal) {
        if (!val) {
          this.error = '';
        }
      }
    },
    isResetInfo: {
      handler: function (val, oldVal) {
        if (!val) {
          this.info = '';
        }
      }
    },
  },
  methods: {
    ...mapActions('users', ['resetPass']),
    tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const { email } = this;
        this.isResetError = false;
        this.isResetInfo = true; this.info = 'Loading ...';
        if (email) {
          this.resetPass(email).then((response) => {
            this.textAlert = "Please, check your email.";
            this.isResetInfo = false;
            this.showAlert = true;
          }).catch((error) => {
            this.isResetInfo = false;
            this.error = error;
            this.isResetError = true;
          });
        }
      }
    },
  },
};
</script>

<template>
  <Auth>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <div class="auth-logo">
                <router-link to="/" class="logo logo-dark text-center">
                  <span class="logo-lg">
                    <img
                      src="@/assets/images/logo-dark.png"
                      alt=""
                      height="22"
                    />
                  </span>
                </router-link>

                <router-link to="/" class="logo logo-light text-center">
                  <span class="logo-lg">
                    <img
                      src="@/assets/images/logo-light.png"
                      alt=""
                      height="22"
                    />
                  </span>
                </router-link>
              </div>
              <p class="text-muted mb-4 mt-3">
                Enter your email address and we'll send you an email to reset your password.
              </p>
            </div>

            <form action="#" @submit.prevent="tryToReset">
              <b-alert
                v-model="isResetInfo"
                class="mb-4"
                variant="info"
                dismissible
                >{{ info }}</b-alert
              >
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >
              <div class="form-group mb-3">
                <label for="emailaddress">Email address</label>
                <input
                  v-model="email"
                  class="form-control"
                  type="email"
                  id="emailaddress"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                  placeholder="Enter your email"
                />
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </div>

              <div class="form-group mb-0 text-center">
                <button class="btn btn-primary btn-block" type="submit" :disabled="isResetInfo">
                  Reset Password
                </button>
              </div>
            </form>

            <b-modal
              id="info-alert-modal"
              body-class="p-4"
              hide-header
              hide-footer
              size="sm"
              v-model="showAlert"
            >
              <div class="text-center">
                <i class="bx bxs-info-circle h1 text-info"></i>
                <h4 class="mt-2">Info</h4>
                <p class="mt-3">{{textAlert}}</p>
                <button
                  type="button"
                  class="btn btn-info my-2"
                  v-on:click="showAlert=false"
                >OK</button>
              </div>
            </b-modal>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="row mt-3">
          <div class="col-12 text-center">
            <p class="text-muted">
              Back to
              <router-link
                to="/login"
                class="text-primary font-weight-medium ml-1"
                >Log in</router-link
              >
            </p>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Auth>
</template>
